import { render, staticRenderFns } from "./MenuCollapseToggle.vue?vue&type=template&id=289a4528&scoped=true"
import script from "./MenuCollapseToggle.vue?vue&type=script&lang=ts"
export * from "./MenuCollapseToggle.vue?vue&type=script&lang=ts"
import style0 from "./MenuCollapseToggle.vue?vue&type=style&index=0&id=289a4528&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289a4528",
  null
  
)

export default component.exports